"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendCustomerFeedbackRequestsOptions = void 0;
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let SendCustomerFeedbackRequestsOptions = class SendCustomerFeedbackRequestsOptions {
};
exports.SendCustomerFeedbackRequestsOptions = SendCustomerFeedbackRequestsOptions;
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], SendCustomerFeedbackRequestsOptions.prototype, "departureAtFrom", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], SendCustomerFeedbackRequestsOptions.prototype, "departureAtTo", void 0);
exports.SendCustomerFeedbackRequestsOptions = SendCustomerFeedbackRequestsOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], SendCustomerFeedbackRequestsOptions);
//# sourceMappingURL=SendCustomerFeedbackRequestsOptions.js.map